export const LogoColoredSvg = ({
  className,
  style,
  clipId,
  strokeId,
  mode,
}: {
  className?: string
  style?: React.CSSProperties
  clipId: string
  strokeId: string
  mode: 'light' | 'dark'
}) => {
  return (
    <svg
      width="48"
      height="62"
      viewBox="0 0 48 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <g clipPath={`url(#${clipId})`}>
        <rect
          width="48"
          height="62"
          rx="10"
          fill={mode === 'light' ? 'white' : 'dark'}
        />
        <rect
          x="17.0029"
          y="76.2607"
          width="94"
          height="5"
          transform="rotate(-45 17.0029 76.2607)"
          fill="#FF6C00"
          fillOpacity="0.65"
        />
        <rect
          opacity="0.5"
          x="17.0029"
          y="69.2607"
          width="94"
          height="5"
          transform="rotate(-45 17.0029 69.2607)"
          fill="#FF6C00"
        />
        <rect
          opacity="0.4"
          x="10"
          y="69.2607"
          width="94"
          height="5"
          transform="rotate(-45 10 69.2607)"
          fill="#FF6C00"
        />
        <rect
          opacity="0.35"
          x="3"
          y="69.2607"
          width="94"
          height="5"
          transform="rotate(-45 3 69.2607)"
          fill="#FF6C00"
        />
        <rect
          opacity="0.3"
          x="1"
          y="64.2607"
          width="94"
          height="5"
          transform="rotate(-45 1 64.2607)"
          fill="#FF6C00"
        />
        <rect
          opacity="0.25"
          y="58.2607"
          width="94"
          height="5"
          transform="rotate(-45 0 58.2607)"
          fill="#FF6C00"
        />
        <rect
          opacity="0.2"
          x="-3"
          y="54.2607"
          width="94"
          height="5"
          transform="rotate(-45 -3 54.2607)"
          fill="#FF6C00"
        />
        <rect
          opacity="0.15"
          x="-10"
          y="54.2607"
          width="94"
          height="5"
          transform="rotate(-45 -10 54.2607)"
          fill="#FF6C00"
        />
        <rect
          opacity="0.1"
          x="-17"
          y="54.2607"
          width="94"
          height="5"
          transform="rotate(-45 -17 54.2607)"
          fill="#FF6C00"
        />
      </g>
      <rect
        x="1.5"
        y="1.5"
        width="45"
        height="59"
        rx="8.5"
        stroke={`url(#${strokeId})`}
        strokeWidth="3"
      />
      <defs>
        <linearGradient
          id={strokeId}
          x1="24"
          y1="0"
          x2="24"
          y2="62"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF9B51" />
          <stop offset="1" stopColor="#FF6C00" />
        </linearGradient>
        <clipPath id={clipId}>
          <rect width="48" height="62" rx="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
